<template>
  <div v-if="show">
    <v-alert
      v-if="toastOptions.message"
      class="toast-container"
      :class="toastOptions.status"
      :type="toastOptions.status"
      :title="toastOptions.title"
      :options="{}"
      :closable="!toastOptions.showButtons && true"
      @click:close="show = false"
      variant="outlined"
      :icon="false"
    >
      <template #text>
        <span v-html="toastOptions.message" />
      </template>
      <template #append>
        <v-btn
          v-if="toastOptions.showButtons"
          class="mr-2 mt-6"
          :class="toastOptions.status"
          variant="outlined"
          @click="
            toastOptions.buttonOptions
              ? toastOptions.buttonOptions.action()
              : (show = false)
          "
        >
          <span>
            {{
              toastOptions.buttonOptions
                ? toastOptions.buttonOptions.text
                : 'Close'
            }}
          </span>
        </v-btn>
        <v-btn
          v-if="toastOptions.showButtons"
          class="mt-6"
          :class="toastOptions.status"
          variant="outlined"
          @click="show = false"
        >
          <span>Cancel</span>
        </v-btn>
      </template>
    </v-alert>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';
import { ToastOptions } from '@/Core.UI.Domain/types/Toast';

const show = ref(true);

const props = defineProps<{
  toastOptions: ToastOptions;
}>();

onMounted(() => {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      show.value = false;
    }
  });
});

watch(
  () => props.toastOptions.showToast,
  (value) => {
    show.value = value ?? false;
  }
);
</script>

<style scoped lang="scss">
.toast-container {
  z-index: 1000;
  position: fixed;
  bottom: 5%;
  left: 50%;
  background-color: white;
  transform: translate(-50%, -5%);
}
</style>
